// ExploreMoreHint.jsx
import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { PORTAL_Z_INDEX } from '../component/SideDrawer.jsx';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import { NULL_FUNCTION } from '../resource/defaults.js';

import CleanModeHintImg from '../../img/img_clean_mode_hint.png';
import { color } from '../style/variables.js';

const getModalRoot = () =>
  document.querySelector('#modal-root') || document.body;

export const ExploreMoreHint = ({ onClick = NULL_FUNCTION }) => {
  const { t } = useTranslation();
  return createPortal(
    <StyledExploreMoreHint onClick={onClick}>
      <img src={CleanModeHintImg} alt="hint" />
      <ExploreMoreHintContent>
        {t('tips_livestream_gesture_update_trending_and_followed_creators', {
          ns: TranslationNamespace.LIVESTREAM,
        })}
      </ExploreMoreHintContent>
    </StyledExploreMoreHint>,
    getModalRoot()
  );
};

ExploreMoreHint.propTypes = {
  onClick: PropTypes.func,
};

const StyledExploreMoreHint = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  z-index: ${PORTAL_Z_INDEX};
  border-radius: 4px;
  box-shadow: 0 2px 8px 0 rgba(25, 25, 25, 0.2);
  background: ${color.neutral[10]};

  & > img {
    width: 48px;
    height: 48px;
  }
`;

const ExploreMoreHintContent = styled.div`
  text-align: center;
  font-size: 12px;
  line-height: 18px;
  color: ${color.white};
`;

export default ExploreMoreHint;
